import { CHANGELOG_ALL_APPS_ROLE, type MeResponse } from "@seagames/contracts";

/**
 * Who sees Change Logs. Decided by the API (`/auth/me.changelog_access`: the
 * visibility setting, SUPER_ADMIN always) and re-checked on every request —
 * this only picks what to draw. Optional in the type so the nav's narrower
 * session fixtures read as "no access".
 */
type Session = Pick<MeResponse, "active_role"> & Partial<Pick<MeResponse, "changelog_access">>;

export const canSeeChangelog = (me: Session): boolean => me.changelog_access === true;

/** The app picker and "Who can see this page": SUPER_ADMIN only. */
export const canSeeAllChangelogs = (me: Session): boolean => canSeeChangelog(me) && me.active_role === CHANGELOG_ALL_APPS_ROLE;
